export default __webpack_public_path__ + "static/media/roper_icon.c738354f.png";